import {
  createRouter,
  createWebHistory, NavigationGuardNext,
  RouteLocationNormalized,
  RouteLocationNormalizedLoaded,
  Router, RouteRecordRaw
} from 'vue-router';
import {useSessionStore} from "@/features/auth/stores/session.ts";
import {useTenantStore} from "@/tenant/stores/tenantStore.ts";
import HomeLayout from "../layouts/HomeLayout.vue";
import {authRoutes} from "@/features/auth/routes.ts";
import {ownerRoutes} from "@/features/owners/routes.ts";
import {businessRoutes} from "@/features/business/routes.ts";
import {inventoryRoutes} from "@/features/inventory/routes.ts";
import {
  balanceRoutes,
  globalAppointmentRoutes,
  plansRoutes,
  reportsRoutes,
  supportRoutes,
  systemRoutes,
  visitsRoutes,
} from "@/router/routes/misc.ts";
import {landingRoutes} from "@/features/landing/routes.ts";

const routes: RouteRecordRaw[] = [
  landingRoutes,
  authRoutes,
  {
    path: '/',
    name: 'Home',
    component: HomeLayout,
    meta: {requiresAuth: true},
    redirect: {name: 'Dashboard'},
    children: [
      {
        path: '',
        name: 'Dashboard',
        meta: {requiresAuth: true},
        component: () => import('@/features/dashboard/views/Dashboard.vue'),
      },
      {
        path: 'calendar',
        name: 'Calendar',
        meta: {requiresAuth: true},
        component: () => import('@/features/dashboard/views/calendar/Calendar.vue'),
      },
      ownerRoutes,
      businessRoutes,
      inventoryRoutes,
      balanceRoutes,
      systemRoutes,
      reportsRoutes,
      supportRoutes,
      plansRoutes,
      globalAppointmentRoutes,
      visitsRoutes,
    ]
  },
];

const router: Router = createRouter({
  history: createWebHistory(),
  routes: routes,
});

// @ts-ignore
router.beforeEach(async (to: RouteLocationNormalized, from: RouteLocationNormalizedLoaded, next: NavigationGuardNext) => {
  const useSession = useSessionStore();

  if (!to.meta) {
    to.meta = {requiresAuth: true};
  }

  if (!useSession.isAuthenticated && to.meta.requiresAuth) {
    next({name: 'Login', query: {redirect: to.fullPath}});
    return;
  }

  // Load tenant config if authenticated and not yet loaded
  if (useSession.isAuthenticated && useSession.tenantID) {
    const tenantStore = useTenantStore();
    if (!tenantStore.config) {
      try {
        await tenantStore.loadTenantConfig(useSession.tenantID);
      } catch {
        // Continue with default theme on failure
      }
    }

    // Check feature flag if route requires one
    const requiredFeature = to.meta.feature as string | undefined;
    if (requiredFeature && !tenantStore.isFeatureEnabled(requiredFeature as any)) {
      next({name: 'Dashboard'});
      return;
    }
  }

  next();
});

export default router;
